// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"726":"0eebc63a","847":"465eb1a7"}[chunkId] + ".chunk.js");